<template>
  <div>
    <v-navigation-drawer fixed v-model="drawer" app>
      <v-app-bar flat class="transparent">
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-avatar>
              <img :src="photo">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{fullName}}</v-list-item-title>
              <v-list-item-subtitle>{{time}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-app-bar>
      <v-divider/>
      <v-list dense nav>
        <v-list-item to="/" active-class="primary--text">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/explanation" active-class="primary--text">
          <v-list-item-action>
            <v-icon>assignment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Explanation</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-permission:any="['test-question.editor', 'test-question.reader']">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>assignment</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Test Questions</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/tests/questions/create" v-permission="'test-question.editor'" active-class="primary--text">
            <v-list-item-action>
              <v-icon>add</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Create</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/tests/questions" active-class="primary--text">
            <v-list-item-action>
              <v-icon>update</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Update</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group v-permission:any="['practice.editor', 'practice.reader']">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>assignment</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Practice Questions</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/practice/questions/create" v-permission="'test-question.editor'" active-class="primary--text">
            <v-list-item-action>
              <v-icon>add</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Create</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/practice/questions" active-class="primary--text">
            <v-list-item-action>
              <v-icon>update</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Update</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group v-permission:any="['past-question.editor', 'past-question.reader']">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>assignment</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Past Questions</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/pastquestions/add" v-permission="'past-question.editor'" active-class="primary--text">
            <v-list-item-action>
              <v-icon>add</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Create</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/pastquestions/update" active-class="primary--text">
            <v-list-item-action>
              <v-icon>update</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Update</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group v-permission:any="['docs.editor', 'docs.reader']">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>assignment</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Docs</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/docs/new" v-permission="'docs.editor'" active-class="primary--text">
            <v-list-item-action>
              <v-icon>add</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Create</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/docs/all" active-class="primary--text">
            <v-list-item-action>
              <v-icon>update</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Update</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed dense app :dark="!$vuetify.theme.dark" :color="$vuetify.theme.dark ? '' : 'blue'">
      <v-app-bar-nav-icon @click.native.stop="drawer = !drawer"/>
      <v-toolbar-title v-text="title"/>
      <v-spacer></v-spacer>
      <v-btn icon @click.native.stop="$router.go(-1)">
        <v-icon v-html="'chevron_left'"></v-icon>
      </v-btn>
      <v-btn icon @click.native.stop="reload">
        <v-icon>replay</v-icon>
      </v-btn>
      <v-btn icon @click.native.stop="$router.go(1)">
        <v-icon v-html="'chevron_right'"></v-icon>
      </v-btn>
      <v-btn icon v-if="mathc" @click.native.stop="drawer2 = true">
        <v-icon v-html="'menu'"></v-icon>
      </v-btn>
      <v-btn icon @click.native.stop="changeTheme">
        <v-icon v-html="$vuetify.theme.dark ? 'light_mode' : 'dark_mode'"></v-icon>
      </v-btn>
    </v-app-bar>
    <v-dialog
        v-model="drawer2"
        :fullscreen="$vuetify.breakpoint.mdAndDown"
        :hide-overlay="$vuetify.breakpoint.mdAndDown"
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
            dark
            dense
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="drawer2 = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Questions</v-toolbar-title>
        </v-toolbar>
        <All/>
      </v-card>
    </v-dialog>
    <v-main>
      <v-slide-y-transition mode="out-in">
        <router-view></router-view>
      </v-slide-y-transition>
    </v-main>
    {{onUpdateAbs}}
  </div>
</template>

<script>
import Update from "../pages/pastquestions/update";
import All from "../pages/pastquestions/all";
export default {
  name: "default",
  components: { All, Update },
  computed: {
    photo() {
      return this.$store.state.user && this.$store.state.user.photo
        ? this.$store.state.user.photo
        : "https://www.101computing.net/wp/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
    },
    fullName() {
      return this.$store.state.user && this.$store.state.user.name
        ? this.$store.state.user.name
        : "Update Name";
    },
    mathc() {
      if (!this.$route.path.startsWith("/pastquestions/update/")) {
        this.drawer2 = false;
        return false
      }
      return true;
    },
    onUpdateAbs() {
      let s = this.$store.state.pastQuestionId;
      if (s) {
        this.drawer2 = false;
      }
    },
    theme: {
      set(val) {
        this.$store.commit("toggleTheme");
      },
      get() {
        return this.$store.state.darkTheme;
      },
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      window.localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());
    }
  },
  data: () => ({
    d: false,
    time: new Date().toLocaleTimeString(),
    ti: null,
    clipped: false,
    drawer: false,
    drawer2: false,
    fixed: false,
    routeView: true,
    miniVariant: false,
    right: true,
    rightDrawer: false,
    title: "Admin Panel",
  }),
  mounted() {
    if (this.ti) {
      clearInterval(this.ti);
    }
    this.ti = setInterval(() => {
      let d = new Date();
      this.time = d.toLocaleTimeString();
    }, 1000);
    this.$vuetify.theme.dark = Boolean(window.localStorage.getItem('darkTheme') || 'false')
  },
  watch: {
    '$route' (to, from) {
      if(to.matched[0] && to.matched[0].path === "/pastquestions/update/:qid"){
         this.drawer2 = false
      }
    }
  },
  beforeDestroy() {
    if (this.ti) {
      clearInterval(this.ti);
    }
  },
};
</script>

<style scoped>
</style>
